import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const lMSearchEngineApi = createApi({
  reducerPath: 'lMSearchEngineApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['SearchEngineLinks'],
  endpoints: builder => ({
    getSearchEngineLinks: builder.query({
      query: (params) => ({
        url: `/links/search-engine/`,
        params,
      }),
      providesTags: ['SearchEngineLinks']
    }),

    createSearchEngine: builder.mutation({
      query: body => ({
        url: '/links/search-engine/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['SearchEngineLinks']
    }),
    markingSearchEngine: builder.mutation({
      query: (body) => ({
        url: `/links/search-engine/mark/`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['SearchEngineLinks']
    }),

    getSearchEngineById: builder.query({
      query: id => ({
        url: `/links/search-engine/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'SearchEngineLinks', id }]
    }),

    updateSearchEngineById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/search-engine/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['SearchEngineLinks']
    }),

    deleteSearchEngineById: builder.mutation({
      query: id => ({
        url: `/links/search-engine/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'SearchEngineLinks', id }
      ]
    }),

    getSearchEngineAggregateLinks: builder.query({
      query: () => {
        return `/links/search-engine/aggregate-by-campaign/`
      },
      providesTags: ['SearchEngineLinks']
    })
  })
})

export const {
  useGetSearchEngineLinksQuery,
  useLazyGetSearchEngineLinksQuery,
  useCreateSearchEngineMutation,
  useMarkingSearchEngineMutation,
  useGetSearchEngineByIdQuery,
  useUpdateSearchEngineByIdMutation,
  useDeleteSearchEngineByIdMutation,
  useGetSearchEngineAggregateLinksQuery
} = lMSearchEngineApi
